// Generated by LiveScript 1.6.0
var make;
make = function(){
  return {
    data: null,
    prefix: 'o-',
    watchers: new Map,
    directives: new Map,
    deps: {
      isEvaluating: false,
      currentSet: new Set,
      depMap: new Map,
      versions: new Map
    },
    computedResultFns: new WeakSet,
    batchQueue: null,
    destroyed: false,
    registry: new Map,
    observer: null
  };
};
module.exports = {
  make: make
};